export const RESPONSE_MESSAGE_KEY_MAP = {
  ENQUIRY_SUBMITTED_SUCCESSFULLY: 'ENQUIRY.SUBMITTED_SUCCESSFULLY',
  ENQUIRY_EMAIL_SEND_FAILED: 'COMMON.FOLLOW_UP_INCOMPLETE',
  NEWSLETTER_SUBSCRIBED_SUCCESSFULLY: 'NEWSLETTER.SUBSCRIBED_SUCCESSFULLY',
  NEWSLETTER_EMAIL_SEND_FAILED: 'COMMON.FOLLOW_UP_INCOMPLETE',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  NOT_FOUND: 'COMMON.NOT_FOUND',
  UNAUTHORIZED: 'COMMON.UNAUTHORIZED',
  EXTERNAL_SERVICE_ERROR: 'COMMON.EXTERNAL_SERVICE_ERROR',
  VALIDATION_ERROR: 'COMMON.VALIDATION_ERROR',
  SERVER_ERROR: 'COMMON.SERVER_ERROR',
} as const;
